var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"max-w-6xl mx-auto text-gray-600"},[(!_vm.loading)?_c('div',[_c('div',{staticClass:"px-5 py-20 mx-auto"},_vm._l((_vm.items),function(news){return _c('div',{key:news.newsTitle},[_c('SingleNewsDisplay',{attrs:{"news":news}})],1)}),0)]):_c('div',[_c('img',{staticClass:"w-64 m-auto",attrs:{"src":_vm.loadingImage}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }